export default {
  "about.title": "关于快猫视频",
  "about.brand.title": "品牌故事",
  "about.brand.desc": "快猫视频成立于2020年，是一家专注于短视频创作与分享的互联网科技公司。我们致力于为全球用户提供最优质的短视频创作工具和内容平台，让每个人都能轻松记录和分享生活中的美好瞬间。",
  "about.brand.mission": "让创作更简单，让分享更快乐",
  "about.brand.vision": "成为全球最受欢迎的短视频创作与分享平台",
  "about.reputation.title": "品牌荣誉",
  "about.reputation.desc": "多年来，快猫视频凭借优秀的产品体验和创新能力，获得了行业和用户的广泛认可。",
  "about.contact.title": "联系我们",
  "about.contact.desc": "如果您有任何问题或合作意向，欢迎通过以下方式与我们取得联系。",
  "about.contact.email": "电子邮箱",
  "about.contact.phone": "联系电话",
  "about.contact.address": "公司地址",
  "about.contact.form": "在线留言",
  "about.contact.formName": "姓名",
  "about.contact.formEmail": "邮箱",
  "about.contact.formMessage": "留言内容",
  "about.contact.formSubmit": "提交留言",
  "about.contact.formSuccess": "留言提交成功，我们会尽快回复您！",
  "about.contact.formError": "提交失败，请稍后重试。",
  "about.team.title": "核心团队",
  "about.team.desc": "我们拥有一支充满激情和创造力的团队，致力于为用户打造极致的产品体验。",
};